module.exports = __webpack_public_path__ + "static/media/block-neutral.e2bb138e.png";


//////////////////
// WEBPACK FOOTER
// ./src/story/sprites/block-neutral.png
// module id = 83
// module chunks = 0